import { render, staticRenderFns } from "./LicenseImg.vue?vue&type=template&id=1f8e7837&scoped=true&"
import script from "./LicenseImg.vue?vue&type=script&lang=js&"
export * from "./LicenseImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8e7837",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCard,VDialog,VImg,VSlider})
